import { computed } from "@angular/core";
import type { ApplicationFeatureType } from "@core/auth/permissions";
import { patchState, signalStore, withComputed, withMethods, withState } from "@ngrx/signals";
import { filterMenuItems, type MenuItem } from "./compose-menu-items";

const isSidebarOpenKey = "isSidebarOpen";

type State = {
  _items: MenuItem[];
  _applicationFeatures: Set<ApplicationFeatureType>;
  debugVariables: string[];
  isSidebarOpen: boolean;
};

const initialState: State = {
  _items: [],
  _applicationFeatures: new Set(),
  debugVariables: [],
  isSidebarOpen: true,
};

export const MainContainerStore = signalStore(
  withState(initialState),
  withMethods((state) => ({
    initialize(
      items: MenuItem[],
      applicationFeatures: Set<ApplicationFeatureType>,
      debugVariables: string[],
    ) {
      const isSidebarOpenFromStorage = localStorage.getItem(isSidebarOpenKey);

      if (isSidebarOpenFromStorage == null) {
        localStorage.setItem(isSidebarOpenKey, String(initialState.isSidebarOpen));
      }

      patchState(state, {
        _items: items,
        _applicationFeatures: applicationFeatures,
        debugVariables: debugVariables,
        isSidebarOpen: localStorage.getItem(isSidebarOpenKey) === "true",
      });
    },
    toggleSidebarOpenState() {
      patchState(state, { isSidebarOpen: !state.isSidebarOpen() });
      localStorage.setItem(isSidebarOpenKey, String(state.isSidebarOpen()));
    },
  })),
  withComputed((state) => ({
    items: computed(() => filterMenuItems(state._items(), state._applicationFeatures())),
  })),
);
